import { commonViewTexts } from '../common';

export const modelRootViewTexts = {
  tabs: {
    overview: '概要',
    labelList: 'ラベル一覧',
    modelImageList: `${commonViewTexts.blueprintData}管理`
  }
} as const;
